import reducer from './reducer'

import * as facilitiesOperations from './operations'
import * as facilitiesSelectors from './selectors'

export { facilitiesOperations, facilitiesSelectors }

export default reducer
